import Link from 'next/link'
import { FaRegQuestionCircle, FaWhatsapp } from 'react-icons/fa'
import cl from 'classnames'

type Props = {
  className?: string
}

export const MenuContentFaleConosco = ({ className }: Props) => {
  return (
    <div
      className={cl(
        'flex flex-col lg:flex-row gap-4 md:gap-8 mt-4 mb-2 max-h-[200px] pb-2 overflow-auto',
        className
      )}
    >
      <div className="flex flex-col md:flex-row lg:flex-col gap-2">
        <Link
          href="https://api.whatsapp.com/send?phone=11972132657"
          className="w-full lg:min-w-[272px] h-11 md:h-16 flex items-center justify-center bg-[#2378041A] gap-2 rounded-lg"
        >
          <FaWhatsapp className="w-5 h-5  text-[#237804]" />
          <span className="text-base md:text-xl md:leading-6 tracking-[0.8px] text-[#237804]">
            Fale Conosco
          </span>
        </Link>

        <Link
          href="/faq-solar"
          className="w-full lg:min-w-[272px] h-11 md:h-16 flex items-center justify-center bg-[#0958D91A] gap-2 rounded-lg"
        >
          <FaRegQuestionCircle className="w- h-5 text-[#0958D9]" />
          <span className="text-base md:text-xl md:leading-6 tracking-[0.8px] text-[#0958D9]">
            Perguntas Frequentes
          </span>
        </Link>
      </div>

      <div className="flex flex-col gap-1 md:gap-2 lg:gap-4">
        <span className="text-[10px] md:text-sm leading-4 tracking-[1.2px] font-semibold md:font-normal text-[#00000073] uppercase">
          Atendimento
        </span>

        <div className="flex flex-col md:gap-1">
          <p className="text-base leading-8 tracking-[0.5px] text-[#000000E0]">
            E-mail:{' '}
            <span className="font-semibold">contato@portalsolar.com.br</span>
          </p>
        </div>
      </div>
    </div>
  )
}
